import { makeAutoObservable } from 'mobx';

import { AvailableGameAction } from '../../model/AvailableGameAction';
import { Card } from '../../model/Card';
import { GameStage } from '../../model/enumeration/GameStage.enum';
import { GameResponse } from '../../model/GameResponse';
import { Player } from '../../model/Player';
import { dateFromString } from '../../utils/date.utils';
import { GameTable } from './GameTable';

export class GameState {
  public id?: string;
  public table?: GameTable;

  public activePid?: string;

  public board: Card[] = [];
  public board2: Card[] = [];
  public board3: Card[] = [];

  public shownWinBoard: number;

  public stage?: GameStage;

  public pot = 0;
  public guestPot = 0;

  public turnStartingTime?: Date;

  public availableAction: AvailableGameAction;
  public lastAvailableAction: AvailableGameAction;

  constructor() {
    makeAutoObservable(this);
  }

  initGame(game: GameResponse): void {
    Object.assign(this, game);

    this.turnStartingTime = dateFromString(game.turnStartingTime);
    if (game.table.players.filter(player => player?.won > 0).length > 0) {
      if (game.board3) {
        this.shownWinBoard = 3;
      } else if (game.board2) {
        this.shownWinBoard = 2;
      } else {
        this.shownWinBoard = 1;
      }
    }
  }

  copyGame(game: GameState): void {
    Object.assign(this, game);
  }

  resetActivePlayer(): void {
    this.activePid = null;
    this.turnStartingTime = null;
    this.setAvailableAction(null);
  }

  setId(value: string): void {
    this.id = value;
  }

  setTable(value: GameTable): void {
    this.table = value;
  }

  setBoard(value: Card[]): void {
    this.board = value;
  }

  setBoard2(value: Card[]): void {
    this.board2 = value;
  }

  setBoard3(value: Card[]): void {
    this.board3 = value;
  }

  setStage(value: GameStage): void {
    this.stage = value;
  }

  setPot(value: number): void {
    this.pot = value;
  }

  setGuestPot(value: number): void {
    this.guestPot = value;
  }

  setPlayers(value: Player[]): void {
    this.table.players = value;
  }

  get players(): (Player | null)[] {
    return this.table.players;
  }

  setActivePid(value: string): void {
    this.activePid = value;
  }

  setTurnStartingTime(value: Date): void {
    this.turnStartingTime = value;
  }

  setShownWinBoard(value: number): void {
    this.shownWinBoard = value;
  }

  setAvailableAction(value: AvailableGameAction): void {
    if (this.availableAction != null) {
      this.lastAvailableAction = this.availableAction;
    }
    this.availableAction = value;
  }
}
